module.exports = __webpack_public_path__ + "img/stock0.3b2ce793.png";